import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import MaterialIcon, {colorPalette} from 'material-icons-react';
import { removeUserSession, getUserName, getRole } from '../utils/common';
import { Role } from '../utils/role';
import LanguageSwitcher from '../misc/LanguageSwitcher';

const TopHeader = (props) => {

  const { t } = useTranslation();
  const [userName, setUserName] = useState(getUserName());

  // Farmer and Admin see the same header; Worker/Digiviewer get a cut-down one.
  const canManage = getRole() == Role.Farmer || getRole() == Role.Admin;

  const logout = ()=>{
    removeUserSession();
    window.location = '/login';
  }

  return (
    <div>
      <nav className="main-header navbar-fixed-top navbar navbar-expand-md navbar-light navbar-white">
        <div className="container-fluid">
          <NavLink exact to="/dashboard" className="navbar-brand">
            <img src="/dist/img/logo.png" height="36" alt="iPoultry" />
          </NavLink>
          <button
            className="navbar-toggler order-1"
            type="button"
            data-toggle="collapse"
            data-target="#navbarCollapse"
            aria-controls="navbarCollapse"
            aria-expanded="false"
            aria-label={t('common:nav.toggleNavigation')}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse order-3" id="navbarCollapse">
            <ul className="navbar-nav navBar">
              <li className="nav-item">
                <NavLink exact to="/dashboard" className="nav-link">
                  {t('nav.dashboard')}
                </NavLink>
              </li>
              <li className="nav-item dropdown">
                <a id="navFarmManagement" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="nav-link dropdown-toggle">{t('nav.farmManagement')}</a>
                <ul aria-labelledby="navFarmManagement" className="dropdown-menu border-0 shadow">
                  {canManage &&
                    <>
                      <NavLink exact to="/addBarn" className="nav-link">
                        {t('nav.addBarn')}
                      </NavLink>
                      <NavLink exact to="/addBatch" className="nav-link">
                        {t('nav.addBatch')}
                      </NavLink>
                    </>
                  }
                  <NavLink exact to="/batchOperations" className="nav-link">
                    {t('nav.batchOperations')}
                  </NavLink>
                  {canManage &&
                    <>
                      <NavLink exact to="/batchHistory" className="nav-link">
                        {t('nav.batchHistory')}
                      </NavLink>
                      {/* <NavLink exact to="/listofbarns" className="nav-link">
                        List of Barns
                      </NavLink> */}
                      <NavLink exact to="/addtemplates" className="nav-link">
                        {t('nav.addTemplates')}
                      </NavLink>
                      <NavLink exact to="/templates" className="nav-link">
                        {t('nav.listOfTemplates')}
                      </NavLink>
                      {/* <NavLink exact to="/batchSummary" className="nav-link">
                        Batch Summary
                      </NavLink> */}
                    </>
                  }
                  <NavLink exact to="/managefans" className="nav-link">
                    {t('nav.manageFans')}
                  </NavLink>
                </ul>
              </li>
              {canManage &&
                <>
                  <li className="nav-item dropdown">
                    <a id="navUserManagement" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="nav-link dropdown-toggle">{t('nav.userManagement')}</a>
                    <ul aria-labelledby="navUserManagement" className="dropdown-menu border-0 shadow">
                      <NavLink exact to="/adduser" className="nav-link">
                        {t('nav.createNewUser')}
                      </NavLink>
                      <NavLink exact to="/users" className="nav-link">
                        {t('nav.listOfUsers')}
                      </NavLink>
                      {getRole() == Role.Admin &&
                        <>
                          <NavLink exact to="/appVideos" className="nav-link">
                            {t('nav.videos')}
                          </NavLink>
                          <NavLink exact to="/integrators" className="nav-link">
                            {t('nav.integratorsMaster')}
                          </NavLink>
                        </>
                      }
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a id="navReportsAnalytics" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="nav-link dropdown-toggle">{t('nav.reportsAnalytics')}</a>
                    <ul aria-labelledby="navReportsAnalytics" className="dropdown-menu border-0 shadow">
                      <NavLink exact to="/batchmortality" className="nav-link">
                        {t('nav.chickMortality')}
                      </NavLink>
                      {/* <NavLink exact to="/growthcurve" className="nav-link">
                        {t('nav.growthCurve')}
                      </NavLink> */}
                      <NavLink exact to="/growthcurvenew" className="nav-link">
                        {t('nav.growthCurve')}
                      </NavLink>
                      <NavLink exact to="/idealweightcomparison" className="nav-link">
                        {t('nav.idealWeights')}
                      </NavLink>
                      <NavLink exact to="/dopReport" className="nav-link">
                        {t('nav.dailyOperations')}
                      </NavLink>
                      <li className="dropdown-submenu">
                        <a className="nav-link dropdown-toggle" href="#">{t('nav.batchComparison')}</a>
                        <ul className="dropdown-menu">
                          <NavLink exact to="/batchcomparison" className="nav-link">
                            {t('nav.pef')}
                          </NavLink>
                          <NavLink exact to="/avgbirdweightcomparison" className="nav-link">
                            {t('nav.avgBirdWeight')}
                          </NavLink>
                          <NavLink exact to="/fcrcomparison" className="nav-link">
                            {t('nav.fcr')}
                          </NavLink>
                          <NavLink exact to="/growthcomparison" className="nav-link">
                            {t('nav.growth')}
                          </NavLink>
                        </ul>
                      </li>
                      <NavLink exact to="/heatstressanalytics" className="nav-link">
                        {t('nav.heatStressAnalytics')}
                      </NavLink>
                    </ul>
                  </li>
                  <li className="nav-item dropdown">
                    <a id="navDeviceManagement" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" className="nav-link dropdown-toggle">{t('nav.deviceManagement')}</a>
                    <ul aria-labelledby="navDeviceManagement" className="dropdown-menu border-0 shadow">
                      <NavLink exact to="/managedevices" className="nav-link">
                        {t('nav.listOfDevices')}
                      </NavLink>
                      <NavLink exact to="/sesorcalibration" className="nav-link">
                        {t('nav.sensorCalibration')}
                      </NavLink>
                      <NavLink exact to="/controlSystem" className="nav-link">
                        {t('nav.coolingPads')}
                      </NavLink>
                    </ul>
                  </li>
                </>
              }
            </ul>
          </div>

          {/* Right-hand actions: language | user menu. Both sit on the same
              34px pill height so the bar reads as one row. The old
              "Logged as:" label is gone — the username pill says it, and
              dropping it recovers ~120px in Malay ("Log masuk sebagai:"),
              which is what used to wrap the navbar on 1280px laptops. It
              survives as the pill's tooltip / accessible name. */}
          <ul className="order-1 order-md-3 navbar-nav navbar-no-expand headerActions ml-auto">
            <LanguageSwitcher variant="header" />
            <li className="headerActionsDivider" aria-hidden="true"></li>
            <li className="nav-item dropdown">
              <a
                className="nav-link loggedasButton"
                data-toggle="dropdown"
                href="#"
                title={`${t('nav.loggedAs')} ${userName}`}
                aria-label={`${t('nav.loggedAs')} ${userName}`}
              >
                <i className="fa fa-user-circle" aria-hidden="true"></i>
                <span className="loggedasName">{userName}</span>
                <i className="fa fa-caret-down" aria-hidden="true"></i>
              </a>
              <div className="dropdown-menu dropdown-menu-md dropdown-menu-right">
                <NavLink exact to="/myprofile" className="dropdown-item">
                  {t('nav.myProfile')}
                </NavLink>
                <div className="dropdown-divider"></div>
                <button type="button" className="dropdown-item" onClick={logout}>
                  {t('nav.logout')}
                </button>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </div>
  );
};
export default TopHeader;
